import {OrderDelivery} from '../../delivery/models/order-delivery.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {CustomerContractModel} from '@cc-commons/models/contract-details.model';
import {UserV3PersonalDetailsModel} from '@shared/models/user-v-3.model';
import {
	CROSS_PERMISSION_DIGITAL_SIGNATURE_PROPERTY_CERTIFICATE_ALIAS,
	CROSS_PERMISSION_DIGITAL_SIGNATURE_PROPERTY_DOMAIN
} from '../../permissions-variables';
import {CrossPermissionModel} from '@shared/models/user-permission.model';

export class DigitalSignSigner {
	certificate_alias: string;
	client_signer_id: string;
	infocert_signer_id: string;
	role: string;
	identity_assertion_policy: string;
	legal_id_country_code: string;
	legal_id_serial_type: string;
	legal_id_serial_number: string;
	fiscal_code: string;
	first_name: string;
	last_name: string;
	birth_date: string;
	sex: string;
	citizenship: string;
	birth_place: string;
	birth_province: string;
	birth_country: string;
	email: string;
	mobile_number: string;
	address_street: string;
	address_number: string;
	address_zip: string;
	address_city: string;
	address_province: string;
	address_country: string;
	identity_document_issue_country: string;
	identity_document_type: string;
	identity_document_number: string;
	identity_document_issuer: string;
	identity_document_issue_place: string;
	identity_document_issue_province: string;
	identity_document_issue_date: string;
	identity_document_expiration_date: string;
	process_token: string;
	process_session_key: string;
	certificate_domain: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.client_signer_id = model.client_signer_id;
			this.infocert_signer_id = model.infocert_signer_id;
			this.role = model.role;
			this.identity_assertion_policy = model.identity_assertion_policy;
			this.legal_id_country_code = model.legal_id_country_code;
			this.legal_id_serial_type = model.legal_id_serial_type;
			this.legal_id_serial_number = model.legal_id_serial_number;
			this.fiscal_code = model.fiscal_code;
			this.first_name = model.first_name;
			this.last_name = model.last_name;
			this.birth_date = model.birth_date;
			this.sex = model.sex;
			this.citizenship = model.citizenship;
			this.birth_place = model.birth_place;
			this.birth_province = model.birth_province;
			this.birth_country = model.birth_country;
			this.email = model.email;
			this.mobile_number = model.mobile_number;
			this.address_street = model.address_street;
			this.address_number = model.address_number;
			this.address_zip = model.address_zip;
			this.address_city = model.address_city;
			this.address_province = model.address_province;
			this.address_country = model.address_country;
			this.identity_document_issue_country = model.identity_document_issue_country;
			this.identity_document_type = model.identity_document_type;
			this.identity_document_number = model.identity_document_number;
			this.identity_document_issuer = model.identity_document_issuer;
			this.identity_document_issue_place = model.identity_document_issue_place;
			this.identity_document_issue_province = model.identity_document_issue_province;
			this.identity_document_issue_date = model.identity_document_issue_date;
			this.identity_document_expiration_date = model.identity_document_expiration_date;
			this.process_token = model.process_token;
			this.process_session_key = model.process_session_key;
			if (model.certificate_domain) {
				this.certificate_domain = model.certificate_domain;
			}
			if (model.certificate_alias) {
				this.certificate_alias = model.certificate_alias;
			}
		}
	}

	settingSignerFromUser(model: UserV3PersonalDetailsModel, digitalSignatureProperties: CrossPermissionModel, index: number): DigitalSignSigner {
		if (!Utilities.isVoid(model)) {
			this.client_signer_id = Utilities.getUUID();
			this.infocert_signer_id = 'IR' + index;
			this.role = 'IR';
			this.identity_assertion_policy = 'none';
			this.legal_id_country_code = 'IT';
			this.legal_id_serial_type = 'CF';
			this.legal_id_serial_number = model.tax_code;
			this.fiscal_code = model.tax_code;
			this.first_name = model.firstname;
			this.last_name = model.lastname;
			this.birth_date = model.birth_date;
			this.sex = null;
			this.citizenship = null;
			this.birth_place = model.birth_place;
			this.birth_province = model.birth_province;
			this.birth_country = model.birth_country;
			this.email = model.email;
			this.mobile_number = model.phone;
			this.address_street = null;
			this.address_number = null;
			this.address_zip = null;
			this.address_city = null;
			this.address_province = null;
			this.address_country = null;
			this.identity_document_issue_country = null;
			this.identity_document_type = null;
			this.identity_document_number = null;
			this.identity_document_issuer = null;
			this.identity_document_issue_place = null;
			this.identity_document_issue_province = null;
			this.identity_document_issue_date = null;
			this.identity_document_expiration_date = null;
			this.certificate_domain = digitalSignatureProperties.properties.get(CROSS_PERMISSION_DIGITAL_SIGNATURE_PROPERTY_DOMAIN);
			this.certificate_alias = digitalSignatureProperties.properties.get(CROSS_PERMISSION_DIGITAL_SIGNATURE_PROPERTY_CERTIFICATE_ALIAS);
		}
		return this;
	}

	settingSignerFromOrder(model: OrderDelivery, index: number): DigitalSignSigner {
		if (!Utilities.isVoid(model)) {
			if (!model.delegateExist()) {
				this.client_signer_id = Utilities.getUUID();
				this.infocert_signer_id = 'richiedente' + index;
				this.role = 'richiedente';
				this.identity_assertion_policy = 'inline.devisu';
				this.legal_id_country_code = 'none';
				this.legal_id_serial_type = 'CF';
				this.legal_id_serial_number = model.txt_fiscal_code_driver;
				this.fiscal_code = model.txt_fiscal_code_driver;
				this.first_name = model.txt_driver_name;
				this.last_name = model.txt_driver_surname;
				this.birth_date = DateUtilities.getUTCStringFromDateWithForm(model.date_driver_birth, DateUtilities.dateAndTime);
				this.sex = model.txt_driver_gender;
				//this.citizenship = model.txt_driver_citizenry;
				this.birth_place = model.txt_driver_birthplace;
				//this.birth_province = model.txt_driver_birthprovince;
				//this.birth_country = model.txt_driver_birthstate;
				this.email = model.txt_driver_email;
				this.mobile_number = model.txt_driver_phone;
				this.address_street = model.txt_driver_address;
				this.address_number = model.txt_driver_address_number;
				this.address_zip = model.txt_driver_zip_code;
				this.address_city = model.txt_driver_city;
				//this.address_province = model.txt_driver_address_province;
				//this.address_country = model.txt_driver_address_country;
				this.identity_document_issue_country = model.txt_driver_license_issue_country;
				this.identity_document_type = 'PT';
				this.identity_document_number = model.txt_driver_license_number;
				this.identity_document_issuer = model.txt_driver_license_by;
				//this.identity_document_issue_place = model.txt_driver_license_issue_place;
				//this.identity_document_issue_province = model.txt_driver_license_issue_province;
				this.identity_document_issue_date = DateUtilities.getUTCStringFromDateWithForm(model.ordercardelivery_date_license_release_textbox, DateUtilities.dateAndTime);
				this.identity_document_expiration_date = DateUtilities.getUTCStringFromDateWithForm(model.ordercardelivery_date_license_validity_textbox, DateUtilities.dateAndTime);
			} else {
				this.client_signer_id = Utilities.getUUID();
				this.infocert_signer_id = 'richiedente' + index;
				this.role = 'richiedente';
				this.identity_assertion_policy = 'inline.devisu';
				this.legal_id_country_code = 'none';
				this.legal_id_serial_type = 'CF';
				this.legal_id_serial_number = model.txt_fiscal_code_delegate;
				this.fiscal_code = model.txt_fiscal_code_delegate;
				this.first_name = model.txt_delegate_name;
				this.last_name = model.txt_delegate_surname;
				this.birth_date = DateUtilities.getUTCStringFromDateWithForm(model.date_delegate_birth, DateUtilities.dateAndTime);
				this.sex = model.txt_delegate_gender;
				//this.citizenship = model.txt_delegate_citizenry;
				this.birth_place = model.txt_delegate_birthplace;
				//this.birth_province = model.txt_delegate_birthprovince;
				//this.birth_country = model.txt_delegate_birthstate;
				this.email = model.txt_delegate_email;
				this.mobile_number = model.txt_delegate_phone;
				this.address_street = model.txt_delegate_address;
				this.address_number = model.txt_delegate_address_number;
				this.address_zip = model.txt_delegate_zip_code;
				this.address_city = model.txt_delegate_city;
				//this.address_province = model.txt_delegate_address_province;
				//this.address_country = model.txt_delegate_address_country;
				this.identity_document_issue_country = model.txt_delegate_license_issue_country;
				this.identity_document_type = 'PT';
				this.identity_document_number = model.txt_delegate_license_number;
				this.identity_document_issuer = model.txt_delegate_license_by;
				//this.identity_document_issue_place = model.txt_delegate_license_issue_place;
				//this.identity_document_issue_province = model.txt_delegate_license_issue_province;
				this.identity_document_issue_date = DateUtilities.getUTCStringFromDateWithForm(model.date_delegate_license_release, DateUtilities.dateAndTime);
				this.identity_document_expiration_date = DateUtilities.getUTCStringFromDateWithForm(model.date_delegate_license_validity, DateUtilities.dateAndTime);
			}
		}
		return this;
	}

	settingSignerFromCustomer(model: CustomerContractModel, index: number): DigitalSignSigner {
		if (!Utilities.isVoid(model)) {
			this.client_signer_id = Utilities.getUUID();
			this.infocert_signer_id = 'richiedente' + index;
			this.role = 'richiedente';
			this.identity_assertion_policy = 'inline.devisu';
			this.legal_id_country_code = 'none';
			this.legal_id_serial_type = 'CF';
			this.legal_id_serial_number = model.fiscal_code;
			this.fiscal_code = model.fiscal_code;
			this.first_name = model.name;
			this.last_name = model.surname;
			this.birth_date = model.date_of_birth;
			this.sex = model.gender;
			this.birth_place = model.birth_place;
			this.email = model.email;
			this.mobile_number = model.phone;
			this.address_street = model.address;
			this.address_number = model.address_number;
			this.address_zip = model.zip_code;
			this.address_city = model.city;
			this.identity_document_issue_country = model.license_issue_country;
			this.identity_document_type = 'PT';
			this.identity_document_number = model.license_number;
			this.identity_document_issuer = model.license_by;
			this.identity_document_issue_date = model.license_release;
			this.identity_document_expiration_date = model.license_validity;
		}
		return this;
	}
}
